export default __webpack_public_path__ + "static/media/EIGHTS-logo.7f4d8b44.png";